import values from 'lodash/fp/values'
import PropTypes from 'prop-types'


const constants = {
    ACTIVE: 'ACTIVE',
    INVALID: 'INVALID',
    POSTPONE: 'POSTPONE',
    READY_TO_MIGRATE: 'READY_TO_MIGRATE',
    REGISTER: 'REGISTER'
}

export const types = PropTypes.oneOf(values(constants))

export default constants
